import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimary from '@/views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-konfortify-banner.js';

const buttonHtml = buttonPrimary({
  text: 'Shop now',
  backgroundColor: '#000000',
  color: '#FFFFFF',
  radius: 0,
  show: false,
  iconPrefix: { show: false, src: '' },
  iconSuffix: { show: false, src: '' },
  subBtn: { show: false, text: '' },
});

const contentHtml = `
  <div data-attribute="konfortify-banner" class="konfortify-banner" data-image-position="right" data-image-show="true">
    <div data-attribute="konfortify-banner__layout" class="konfortify-banner__layout">
      <div data-attribute="konfortify-banner__media" class="konfortify-banner__media" data-show="true" data-shape-curved-show="true">
        <img data-attribute="konfortify-banner__image" src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0dcf21ebaf94bd2c237a6.webp?w=1000" alt="Konfortify promotion" />
        <svg
          class="konfortify-banner__shape-desktop"
          width="77"
          height="559"
          viewBox="0 0 77 559"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M.416016 0v.49646C46.5342 52.1643 77 163.62 77 279.5 77 395.412 50.9778 500.997.416016 558.496V559H77V0H.416016Z"
            fill="#e2ecfd"
          ></path>
        </svg>
        <svg
          class="konfortify-banner__shape-mobile"
          width="1118"
          height="154"
          viewBox="0 0 1118 154"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 153.16h.992868C104.323 60.9285 327.224.00001207 558.971.00000194 790.784-.00000819 1001.94 52.0417 1116.93 153.16h1.01V-.0000225L558.971.00000195-.0000067.00002637 0 153.16Z"
            fill="#fff"
          ></path>
        </svg>
      </div>
      <div data-attribute="konfortify-banner__content-box" class="konfortify-banner__content-box" data-background-color="#E2ECFD" data-text-color="#000000" style="--content-background-color: #E2ECFD; --content-text-color: #000000">
        <div data-attribute="konfortify-banner__content" class="konfortify-banner__content">
          <h2 style="text-align:center;"><span style="font-size:40px;"><strong>PROMO ENDS SOON!</strong></span></h2>
          <p style="text-align: center">
            Prices will return to normal at the end of the countdown.
          </p>
        </div>
        <div data-attribute="konfortify-banner__button" class="konfortify-banner__button">
          ${buttonHtml}
        </div>
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#FFFFFF',
  textColor: '#000000',
  topPadding: false,
  bottomPadding: false,
});
